// extracted by mini-css-extract-plugin
export default {"solidBorder":"bb2045b6bdebae9ead9ee7fcaa84b523"};